import { useTranslation } from 'react-i18next'
import type { TFunction } from 'i18next'
import { ArrowRightCircle, CheckCircle2, XCircle } from 'lucide-react'
import { InstanceStatus } from '@/api/model/instanceStatus'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/shadcn/tooltip'

// Status → icon/color/tooltip, like the old portal. The backend enum is finer-grained:
// all Completed/Closed variants share the same rendering + tooltip.
function display(status: InstanceStatus, t: TFunction): { Icon: typeof ArrowRightCircle; className: string; label: string } {
  switch (status) {
    case InstanceStatus.Open:
      return { Icon: ArrowRightCircle, className: 'text-muted-foreground', label: t('subtype.status.open') }
    case InstanceStatus.Completed:
    case InstanceStatus.CompletedByEmployeeUser:
    case InstanceStatus.CompletedByCompanyManagementUser:
      return { Icon: CheckCircle2, className: 'text-green-600', label: t('subtype.status.completed') }
    case InstanceStatus.Closed:
    case InstanceStatus.ClosedBySystem:
    case InstanceStatus.Orphaned:
    default:
      return { Icon: XCircle, className: 'text-destructive', label: t('subtype.status.closed') }
  }
}

export function InstanceStatusIcon({ status }: { status: InstanceStatus | null | undefined }) {
  const { t } = useTranslation('incentivation')
  if (!status) return <span className="text-muted-foreground">—</span>
  const { Icon, className, label } = display(status, t)
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="flex items-center">
          <Icon className={`size-4 ${className}`} />
        </span>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  )
}
